import { create } from 'zustand';

export type QueuedToast = {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  duration?: number;
};

// Preserve the source's shared notification channel without opening a Spanel socket.
export const useSocketStore = create<{
  socket: null;
  toastQueue: QueuedToast[];
  addToast: (toast: Omit<QueuedToast, 'id'> & { id?: string }) => void;
  removeQueuedToast: (id: string) => void;
}>((set) => ({
  socket: null,
  toastQueue: [],
  addToast: (toast) => set((state) => ({
    toastQueue: [...state.toastQueue, { ...toast, id: toast.id ?? crypto.randomUUID() }],
  })),
  removeQueuedToast: (id) => set((state) => ({ toastQueue: state.toastQueue.filter((toast) => toast.id !== id) })),
}));
